module.exports = __webpack_public_path__ + "media/images/icons/instagram_circle-36c0a5b26e64504cd7bcd94b513b338c.svg";